import { formatLeaderboardViews } from '@/lib/cpm/formatLeaderboardViews';
import { formatCents } from '@/lib/format/currency';

const MAX_SAFE = BigInt(Number.MAX_SAFE_INTEGER);

function localeFor(language: string): string {
  return language === 'pt' || language.startsWith('pt-') ? 'pt-BR' : 'en-US';
}

function parseMetricBigInt(metric: string): bigint {
  if (!/^-?\d+$/.test(metric.trim())) {
    return 0n;
  }

  try {
    return BigInt(metric);
  } catch {
    return 0n;
  }
}

function fitsSafeInteger(value: bigint): boolean {
  return value >= -MAX_SAFE && value <= MAX_SAFE;
}

export function formatRankMetric(input: {
  trackId: 'views' | 'campaign_money' | 'affiliate' | 'campaigns' | 'renders';
  metric: string;
  language: string;
}): string {
  const { trackId, metric, language } = input;
  const locale = localeFor(language);
  const n = parseMetricBigInt(metric);

  if (trackId === 'views') {
    if (n > MAX_SAFE) {
      return metric;
    }

    const count = Number(n);
    if (count <= 0) {
      return '0';
    }

    return formatLeaderboardViews(count, language);
  }

  if (trackId === 'campaign_money' || trackId === 'affiliate') {
    if (!fitsSafeInteger(n)) {
      return metric;
    }

    return formatCents(Number(n), 'BRL');
  }

  if (!fitsSafeInteger(n)) {
    return metric;
  }

  return new Intl.NumberFormat(locale, {
    maximumFractionDigits: 0,
  }).format(Number(n));
}
